module.exports = __webpack_public_path__ + "static/media/video-320.25128a79.png";